<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showAddMemberToLeaveWorkflow"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Add Employee to Leave Workflow</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Workflow Name</label>
              <input
                v-model="workFlowName.Name"
                type="text"
                required
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1 capitalize">Employee</label>
              <select
                name=""
                id=""
                v-model="info.EmployeeNo"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              >
                <option
                  v-for="employee in employees"
                  :key="employee.Id"
                  :value="employee.EmployeeNo"
                >
                  {{ decryptDataLocal(employee.Fullname, decryptionKey) }}
                </option>
              </select>
            </div>

            <div class="flex justify-end p-5">
              <button
                type="submit"
                class="bg-primary rounded-full px-10 text-sm text-white py-2"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import decryptData from "@/utils/decrypt";
export default {
  name: "CompanySetupCreateLeaveWorkflow",
  props: [
    "showAddMemberToLeaveWorkflow",
    "getWorkflow",
    "workFlowName",
    "getNewMember",
  ],
  components: { Loader },
  data() {
    return {
      decryptDataLocal: "",
      decryptionKey: "",
      info: {
        EmployeeNo: "",
        WorkflowId: "",
      },

      create_error: null,
      create_success: null,
      loading: false,
      employees: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  created() {
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
    this.getEmployees();
  },
  methods: {
    close() {
      this.$emit("close");
      this.info = {
        EmployeeNo: "",
        WorkflowName: "",
      };
      this.selectedEmployees = [];
    },
    create() {
      this.loading = true;
      const data = {
        UploadTimeoffWorkflowMembers: [
          {
            EmployeeNo: this.info.EmployeeNo,
            WorkflowName: this.workFlowName.Name,
            MemberName: this.employees.find(
              (emp) => emp.EmployeeNo === this.info.EmployeeNo
            ).Fullname,
          },
        ],
      };
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .post(
          `${this.getOrganization}/setup/timeoff/workflow/member/${this.$ApiVersion}/upload`,
          JSON.stringify(data),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$notify({
                title: "Success",
                message: response.data.StatusMessage,
                type: "success",
              });
              this.getNewMember(data);
              this.$emit("closeOnSuccess");
              this.info = {
                EmployeeNo: "",
                WorkflowName: "",
              };
              this.selectedEmployees = [];
              setTimeout(() => {
                this.create_success = null;
                this.close();
              }, 2500);

              this.getWorkflow();
            } else {
              this.$notify.error({
                title: "Error",
                message: `
                ${response.data.StatusMessage}
                Errors:
                ${response.data.Errors.map((error) => error)}
                `,
              });
              setTimeout(() => {
                this.create_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: "Error", message: error.message });

            setTimeout(() => {
              this.create_error = null;
            }, 2500);
          }
        );
    },
    getEmployees() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$store.commit("setEmployees", response.data.Data);

              this.employees = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.selected-items {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  cursor: pointer;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 0.5rem 0;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 0.375rem 0.375rem;
  overflow-y: auto;
  max-height: 10rem;
}

.dropdown-menu label {
  display: block;
  padding: 0.5rem;
  cursor: pointer;
}

.dropdown-menu input[type="checkbox"] {
  margin-right: 0.5rem;
}

.dropdown-menu label:hover {
  background-color: #f7fafc;
}

.dropdown-menu label:last-of-type {
  margin-bottom: 0;
}

.dropdown-menu::-webkit-scrollbar {
  width: 0.25rem;
}

.dropdown-menu::-webkit-scrollbar-track {
  background-color: #f7fafc;
}

.dropdown-menu::-webkit-scrollbar-thumb {
  background-color: #cbd5e0;
}
</style>
